import { createSlice } from "@reduxjs/toolkit";
import instance from "../../../api/api.js";
import { handleSpinnerLoading } from "../Loading/SpinnerSlice.js";
export const fectchPrevisionGlobale = (payload) => async (dispatch) => {
  dispatch(handleSpinnerLoading(true));
  console.log("fectchPrevisionGlobale", payload.$y);
  try {
    const data = {
      annee: payload.$y,
    };
    console.log("response_prevision_globale_data", data);
    const response_prevision_globale = await instance.post(
      "previsionProprietesGlobale",
      data
    );
    const response_montant_dormants = await instance.post(
      "inactifProprietesGlobale",
      data
    );
    console.log("response_prevision_globale", response_prevision_globale);
    console.log("response_montant_dormants", response_montant_dormants);
    if (
      response_prevision_globale["status"] === 200 &&
      response_montant_dormants["status"] === 200
    ) {
      dispatch(
        fetch_Statistiques_Prevision_Globale({
          data: response_prevision_globale.data.data,
        })
      );
      dispatch(
        fetch_Statistiques_Montant_Dormant({
          data: response_montant_dormants.data.data,
        })
      );
      dispatch(handleSpinnerLoading(false));
    }
  } catch (error) {
    console.log();
  }
};

export const previsionsGlobaleReducer = createSlice({
  name: "previsionsGlobale",
  initialState: {
    data_prevision: [],
    data_Montant_dormant: [],
  },
  reducers: {
    fetch_Statistiques_Prevision_Globale: (state, action) => {
      return {
        ...state,
        data_prevision: action.payload.data,
      };
    },
    fetch_Statistiques_Montant_Dormant: (state, action) => {
      return {
        ...state,
        data_Montant_dormant: action.payload.data,
      };
    },
  },
});

export const {
  fetch_Statistiques_Prevision_Globale,
  fetch_Statistiques_Montant_Dormant,
} = previsionsGlobaleReducer.actions;
export default previsionsGlobaleReducer.reducer;
